/**
 * @type {BookApiAdapter}
 */
export const openLibraryAdapter = {
    name: 'Open Library',

    async fetch(isbn) {
        try {
            const response = await fetch(`https://openlibrary.org/api/books?bibkeys=ISBN:${isbn}&jscmd=data&format=json`);
            const data = await response.json();
            const bookKey = `ISBN:${isbn}`;

            // Si l'ISBN n'existe pas dans leur base de données
            if (!data[bookKey]) {
                console.log(`BD ISBN ${isbn} non trouvée sur Open Library`)
                return null
            }

            const book = data[bookKey];

            let title = book.title;
            let serie = book.subtitle ?? null;
            let volume = "";

            if (book.subtitle && book.title) {
                let dispatch = _extraireSerieAndVolumeFromOpenLibrary(book.title);

                if (dispatch.serie && dispatch.volume) {
                    title = book.subtitle;
                    serie = dispatch.serie;
                    volume = dispatch.volume;
                } else {
                    let dispatch = _extraireSerieAndVolumeFromOpenLibrary(book.subtitle);

                    if (dispatch.serie && dispatch.volume) {
                        title = book.title;
                        serie = dispatch.serie;
                        volume = dispatch.volume;
                    }
                }
            }

            // Mappage (parsing) des données brutes de l'API vers notre modèle de données local
            return {
                isbn: isbn,
                title: title ?? null,
                authors: book.authors?.map(a => a.name).join(', ') ?? null,
                publisher: book.publishers?.map(p => p.name).join(', ') ?? null,
                series: serie ?? null,
                volume: volume ?? null,
                coverUrl: book.cover?.large?.replace('http:', 'https:') ?? null,
            };
        } catch (error) {
            console.error("Erreur réseau lors de l'appel à Open Library :", error);
            return null
        }
    }
};

/**
 * Extrait intelligemment le nom de la série et le numéro du tome depuis une chaîne brute.
 * Gère les formats multilingues comme "Série, tome 3", "Série Vol 3", etc.
 * @param {string} rawString - La chaîne brute contenant potentiellement la série et le tome.
 * @returns {{ series: string, volume: string }} Un objet contenant la série et le tome proprement séparés.
 */
function _extraireSerieAndVolumeFromOpenLibrary(texteBrut) {
    texteBrut = texteBrut.trim();

    // On initialise nos variables par défaut (le cas où le pattern n'est pas trouvé)
    let serie = texteBrut;
    let volume = "";

    // Le fameux "pattern" (Regex)
    // Il cherche : "n'importe quel texte" suivi de ", tome " (ou juste " tome ") suivi de "chiffres" à la fin.
    const regex = /^(.*?)(?:,?\s*tome\s+(\d+))$/i;

    // On teste le texte contre notre pattern
    const resultat = texteBrut.match(regex);

    if (resultat) {
        // Si le pattern est trouvé, on remplace nos variables
        serie = resultat[1].trim(); // Le groupe 1 correspond à la série (le trim enlève les espaces en trop)
        volume = resultat[2];         // Le groupe 2 correspond aux chiffres du tome
    }

    // On renvoie un objet propre avec nos deux variables séparées
    return { serie, volume };
}
